import {
    BASE_CHANGE_FIELD
} from './actions.types';
import { NBase } from './interface';

export const baseChangeField = (payload: NBase.NActions.ChangeFieldPayload): NBase.Actions => ({
    type: BASE_CHANGE_FIELD,
    payload
});